import './Hero.css'
function Hero() {
  return (
    <div id="home" className="hero">
      <h1>Sustainable Energy Solutions</h1>
      <p>Professional digital catalogue for renewable energy products</p>

      <div
        id="carouselExampleControls"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              className="d-block w-100"
              src="https://tse1.mm.bing.net/th/id/OIP.s3j71cu2JuShyISc99DhqQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3"
              alt="Solar Panels"
            />
          </div>

          <div className="carousel-item">
            <img
              className="d-block w-100"
              src="https://img.thecdn.in/333283/1701344030363_2killowattoffgridutlcombogamma35501.jpeg?width=600&format=webp"
              alt="Battery Systems"
            />
          </div>

          <div className="carousel-item">
            <img
              className="d-block w-100"
              src="https://kenbrooksolar.com/wp-content/uploads/3kW-Luminous-Solar-Complete-System-Panels-5.5kVA-Cruze-Combo-Inverter-and-Battery.png"
              alt="Solar Inverter"
            />
          </div>
        </div>

        {/* Previous Button */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        {/* Next Button */}
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default Hero;
